import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { useCore } from 'contexts/core';
import { ComponentIds, ProductComponent } from '@inter-ikea-core/core';
import SegmentedControl from '@ingka/segmented-control';

const ToggleWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space.md};
`;

export const DirectionFilter = () => {
  const { formatMessage } = useIntl();
  const coreApi = useCore();
  const selectedEntity = coreApi.entities.findSelectedEntity();

  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const productRef = selectedEntity?.getComponent<ProductComponent>(
      ComponentIds.PRODUCT_COMPONENT_ID
    )?.productRef;

    if (productRef) {
      const defaultIndex = productRef.includes('left') ? 0 : 1;
      setSelectedIndex(defaultIndex);
    }
  }, [selectedEntity, coreApi]);

  const items = [
    { label: formatMessage({ id: 'storageone.left' }), icon: '' },
    { label: formatMessage({ id: 'storageone.right' }), icon: '' }
  ];

  const onToggleSelect = (index: number) => {
    setSelectedIndex(index);

    const productRef = selectedEntity?.getComponent<ProductComponent>(
      ComponentIds.PRODUCT_COMPONENT_ID
    )?.productRef;

    const newProductRef =
      productRef && productRef.replace(/(left|right)/, index === 0 ? 'left' : 'right');

    if (productRef && newProductRef) {
      const replacePlacementResult = coreApi.products.replace(selectedEntity.id, newProductRef);
      const placedEntity = replacePlacementResult?.replacedEntityResult?.placedEntity;
      placedEntity && coreApi.entities.select(placedEntity);
    }
  };

  return (
    <ToggleWrapper>
      <SegmentedControl
        items={items}
        activeIndex={selectedIndex}
        onClick={(_e, value) => onToggleSelect(value)}
      />
    </ToggleWrapper>
  );
};
